module.exports = "https://trybtryb-legacy.web.app/img/to_top_left.215c80dd.svg";